import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './OptionChains.css';
import { format, parseISO } from 'date-fns';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { Vortex } from 'react-loader-spinner'
import FandOOpt from "../FandOOpt";

function OptionChains() {
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const [Optiondata, setOptiondata] = useState([])

    const [Optiondatacall, setOptiondatacall] = useState([]);
    const [type, settype] = useState('put');
    const [DateDrp, setDate] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [OptionDate, setOptionDate] = useState([]);
    const [Symbol, setSymbol] = useState('Nifty');
    // let navigate = useNavigate();
    const [OptionSymbol, setOptionSymbol] = useState([]);
    const [OptionStrike, setOptionStrike] = useState([]);
    const [StrikePriceFando, setStrikePriceFando] = useState('-');
    const [loadingshow, setloadingshow] = useState(false);
    const [valueschemename, setValueschemename] = useState([]);
    let getOptionChains, getOptionDate, getOptionSymbol,
        getOptionChainscall, getOptionStrike, getUrldate;
    let PageSize = 8;
    let strkPr = document.getElementById("select-strk");

    useEffect(() => {
        window.scrollTo(0, 0)
        setloadingshow(true)
        const getUrldate = BaseURL + "FandOExpDateandSymbol";
        fetch(`${getUrldate}/opt/${Symbol}`)
            .then((response) => response.json())
            .then((dataOptionDate) => {
                getOptionDate = dataOptionDate.data;
                setOptionDate(getOptionDate);
                setloadingshow(false);
                var codename = getOptionDate[0].ExpiryDateText.split(' ').join('-');
                setValueschemename(codename.split(' ').join('-'))

                const getUrlOptionChains = BaseURL + "Optionschain";
                fetch(`${getUrlOptionChains}/${Symbol}/${codename}/-/${StrikePriceFando}`)
                    .then((response) => response.json())
                    .then((dataOptionChains) => {
                        getOptionChains = dataOptionChains.data;
                        setOptiondata(getOptionChains);
                        setloadingshow(false)
                        // console.log(getOptionChains, "getOptionChains")
                    })
                    .catch((error) => {
                    });

            })
            .catch((error) => {
            });
    }, [Symbol])


    useEffect(() => {
        const getUrldate = BaseURL + "FandOExpDateandSymbol";
        fetch(`${getUrldate}/opt/${Symbol}`)
            .then((response) => response.json())
            .then((dataOptionDate) => {
                getOptionDate = dataOptionDate.data;
                setOptionDate(getOptionDate);
                setloadingshow(false);
            })

        fetch(`${getUrldate}/sym/-`)
            .then((response) => response.json())
            .then((dataOptionSymbol) => {
                getOptionSymbol = dataOptionSymbol.data;
                setOptionSymbol(getOptionSymbol);
                var abc = getOptionSymbol;
            })
            .catch((error) => {
            });


        fetch(`${getUrldate}/${DateDrp}/${Symbol}`)
            .then((response) => response.json())
            .then((dataOptionStrike) => {
                getOptionStrike = dataOptionStrike.data;
                setOptionStrike(getOptionStrike);
            })
            .catch((error) => {
            });
        const getUrlOptionChains = BaseURL + "Optionschain";


        fetch(`${getUrlOptionChains}/${Symbol}/${DateDrp}/-/${StrikePriceFando}`)
            .then((response) => response.json())
            .then((dataOptionChains) => {
                getOptionChains = dataOptionChains.data;
                setOptiondata(getOptionChains);
                setloadingshow(false)
                // console.log(getOptionChains, "getOptionChains")
            })
            .catch((error) => {
            });

    }, [StrikePriceFando, Symbol, DateDrp])



    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/futures-and-options">F & O</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Option Chain</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='OptionCh-loser-sc'>
                            <div className='OptionCh-header'>
                                <h2><span>Option Chains</span></h2>
                            </div>
                            <FandOOpt optionValue="Option Chain" optionDrop="Options" />
                            <div className='OptionCh-right'>
                                <div className='OptionCh-inner-select'>
                                    <select id="select-Contr" onChange={(event) => { setStrikePriceFando('-'); setSymbol(event.target.value); document.getElementById("select-date").selectedIndex = "0"; document.getElementById("select-Sym").selectedIndex = "0"; setDate(''); { if (strkPr != null) { strkPr.selectedIndex = "0"; setStrikePriceFando('-') } } }}>
                                        <option value="NIFTY">Select Options Contracts</option>
                                        <option selected>NIFTY</option>
                                        <option>FINNIFTY</option>
                                        <option>BANKNIFTY</option>
                                    </select>
                                </div>
                                <div className='OptionChOR-inner-select'>
                                    <h6>OR</h6>
                                </div>
                                <div className='OptionCh-inner-select'>
                                    <select id="select-Sym" onChange={(event) => { setStrikePriceFando('-'); setSymbol(event.target.value); document.getElementById("select-date").selectedIndex = "0"; document.getElementById("select-Contr").selectedIndex = "0"; setDate(''); { if (strkPr != null) { strkPr.selectedIndex = "0"; setStrikePriceFando('-') } } }}>
                                        <option value={(OptionSymbol[0] != null) ? OptionSymbol[0].symbol.trim() : ''}>Select Symbol</option>
                                        {OptionSymbol && OptionSymbol.map(
                                            ({ symbol }) => (
                                                <option value={symbol.trim()}>{symbol.trim()}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                                <div className='OptionCh-inner-select'>
                                    <select id="select-date" onChange={(event) => { setStrikePriceFando('-'); setDate(event.target.value); { if (strkPr != null) { strkPr.selectedIndex = "0"; setStrikePriceFando('-') } }; }}>
                                        <option value={(OptionDate[0] != null) ? OptionDate[0].ExpiryDateText : ''}>Select Expiry Date</option>
                                        {OptionDate && OptionDate.map(
                                            ({ ExpiryDateText }) => (
                                                <option value={ExpiryDateText.split(' ').join('-')} selected={valueschemename === ExpiryDateText.split(' ').join('-')}>{ExpiryDateText.split(' ').join('-')}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                                <div className='OptionCh-inner-select'>
                                    <select id="select-strk" onChange={(event) => setStrikePriceFando(event.target.value)}>
                                        <option value="-">Select Strike Price</option>
                                        {OptionStrike && OptionStrike.map(
                                            ({ StrikePrice }) => (
                                                <option value={StrikePrice}>{StrikePrice}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className='OptionCh-table table-responsive fixTableHead'>
                                <table className='table fixed_header'>
                                    <thead>
                                        <tr>
                                            <th className="bdrbottom bdrright" colSpan={3}></th>
                                            <th className="bdrright bdrbottom text-center" colSpan={3}>Calls</th>
                                            <th className="bdrbottom text-center" colSpan={3}>Puts</th>
                                        </tr>
                                        <tr>
                                            <th className='text-left'>Symbol</th>
                                            <th className='text-right'>Expiry Date</th>
                                            <th className='text-center bdrright'>Strike Price (&#8377;)</th>
                                            <th className='text-center'>Last Price(&#8377;)</th>
                                            <th className='text-center'>Change(&#8377;)</th>
                                            <th className='text-center bdrright'>Open Interest</th>
                                            <th className='text-center'>Last Price(&#8377;)</th>
                                            <th className='text-center'>Change(&#8377;)</th>
                                            <th className='text-center'>Open Interest</th>
                                        </tr>
                                    </thead>
                                    {(Optiondata === null) ? <div className="errormsgComNew"><h3>No Data Found !!!</h3></div> : ''}

                                    <tbody>
                                        {Optiondata && Optiondata.map(
                                            ({ strikeprice, CallPricePerChange, PutPriceperChange, CallVolume, CallOI, CallOIChange, callbestbuyprice, Putbestbuyprice, callbestsellprice, Putbestsellprice, CallLTP, PutLTP, symbol, expdate, PutOI, PutOIChange, PutVolume }) => (
                                                <tr>
                                                    <td className='text-left'>{symbol}</td>
                                                    <td className='text-right'>{format(parseISO(expdate.split('T')[0]), 'dd-MMM-yyyy')}</td>
                                                    <td className='text-right bdrright'>{strikeprice != null ? strikeprice : 0}</td>
                                                    <td className='text-right'>{CallLTP != null ? CallLTP : 0}</td>
                                                    {/* <td className='text-right'>{CallPricePerChange != null ? CallPricePerChange.toFixed(2) : 0}</td> */}
                                                    <td><p className={CallPricePerChange.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {CallPricePerChange != null ? CallPricePerChange.toFixed(2) : 0} </p></td>
                                                   
                                                    <td className='text-right bdrright'>{CallOI != null ? CallOI.toFixed(2) : 0}</td>
                                                    <td className='text-right'>{PutLTP != null ? PutLTP : 0}</td>
                                               
                                                    <td><p className={(PutPriceperChange != null) ? PutPriceperChange.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right":''}> {PutPriceperChange != null ? PutPriceperChange.toFixed(2) : 0} </p></td>
                                                    <td className='text-right'>{PutOI != null ? PutOI.toFixed(2) : 0}</td>          
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container >
        </>
    );
}

export default OptionChains;
